var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jt-instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 10.3057C12.003 10.3057 10.3056 12.0032 10.3056 14.0002C10.3056 15.9972 12.003 17.6946 14 17.6946C15.997 17.6946 17.6945 15.9972 17.6945 14.0002C17.6945 12.0032 15.997 10.3057 14 10.3057Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.7356 2.91667H9.36515C5.73788 2.91667 2.91667 5.73788 2.91667 9.26439V18.6348C2.91667 22.2621 5.73788 25.0833 9.36515 25.0833H18.7356C22.2621 25.0833 25.0833 22.2621 25.0833 18.6348V9.26439C25.0833 5.73788 22.2621 2.91667 18.7356 2.91667ZM14 19.8439C10.7758 19.8439 8.25682 17.2242 8.25682 14.1008C8.25682 10.9773 10.7758 8.25682 14 8.25682C17.2242 8.25682 19.7432 10.8765 19.7432 14C19.7432 17.1235 17.2242 19.8439 14 19.8439ZM19.9447 9.46591C19.2394 9.46591 18.6348 8.86136 18.6348 8.15606C18.6348 7.45076 19.2394 6.84621 19.9447 6.84621C20.65 6.84621 21.2545 7.45076 21.2545 8.15606C21.2545 8.86136 20.65 9.46591 19.9447 9.46591Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.1507fd94d1b9779161d63cc6f3eccf3c.svg";
export { ForwardRef as ReactComponent };